<div role="dialog" aria-labelledby="chatAppInstallStepsTitle">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title" id="chatAppInstallStepsTitle">{{ 'chatApp.install.stepsTitle' | translate }}</h4>
      <button type="button" class="btn-close" (click)="close()" [attr.aria-label]="'chatApp.common.close' | translate"></button>
    </div>
    <div class="modal-body">
      <ol class="mb-0 ps-3">
        @for (step of steps; track step) {
          <li class="mb-2">{{ step | translate }}</li>
        }
      </ol>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="close()">{{ 'chatApp.common.gotIt' | translate }}</button>
    </div>
  </div>
</div>
